import AuthMiddleware from "@/middleware/auth";

export default [
  {
    path: "/source",
    name: "config.source",
    component: () => import(/* webpackChunkName: "feed" */ "../views/Source.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Fontes",
      layout: "config",
      guards: ["acl", "feature"],
      slug: "config.view",
      featureSlug: "font",
    },
  },
];
